// Constants
import { GIL_API_CHANNEL } from 'constants/api.constants';
// Utilities
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const GET_ONB_STATE_SERVICE_CONFIGURATION = {
  endpoint: 'gil-api-mng-amz-ldg/v1/checkout/orders/:checkoutId/state',
  pathParams: {
    checkoutId: getCheckoutIdFromUrl(),
  },
  ...GIL_API_CHANNEL,
};

export { GET_ONB_STATE_SERVICE_CONFIGURATION };
